export var props = {
  contentId: {
    type: String,
    required: true
  },
  getRemoteText: {
    type: Function,
    required: false
  },
  isPreview: {
    type: Boolean,
    required: false,
    default: false
  },
  actId: {
    type: String,
    required: true
  }
};